'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPortals = require('./react-portals');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortalTargetDefault = function (_PureComponent) {
  (0, _inherits3.default)(PortalTargetDefault, _PureComponent);

  function PortalTargetDefault() {
    (0, _classCallCheck3.default)(this, PortalTargetDefault);
    return (0, _possibleConstructorReturn3.default)(this, (PortalTargetDefault.__proto__ || (0, _getPrototypeOf2.default)(PortalTargetDefault)).apply(this, arguments));
  }

  (0, _createClass3.default)(PortalTargetDefault, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);
  return PortalTargetDefault;
}(_react.PureComponent);

var PortalTarget = function (_PureComponent2) {
  (0, _inherits3.default)(PortalTarget, _PureComponent2);

  function PortalTarget(props) {
    (0, _classCallCheck3.default)(this, PortalTarget);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PortalTarget.__proto__ || (0, _getPrototypeOf2.default)(PortalTarget)).call(this, props));

    _this2.Target = (0, _reactPortals.portalTarget)(props.name)(props.children || PortalTargetDefault);
    return _this2;
  }

  (0, _createClass3.default)(PortalTarget, [{
    key: 'render',
    value: function render() {
      var Target = this.Target;

      return _react2.default.createElement(Target, null);
    }
  }]);
  return PortalTarget;
}(_react.PureComponent);

process.env.NODE_ENV !== "production" ? PortalTarget.propTypes = {
  /**
   * name of the portal, used as a unique identifier
   */
  name: _propTypes2.default.string
} : void 0;
exports.default = PortalTarget;